import { render, staticRenderFns } from "./SignIcon.vue?vue&type=template&id=3bc29893&"
import script from "./SignIcon.vue?vue&type=script&lang=js&"
export * from "./SignIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports